import { Link } from 'react-router-dom';
import React from 'react';

function Instrumente() {
    return (

        <div
            className="bg-intrumente-wrapper view"
            style={{
                backgroundImage: `url(${process.env.PUBLIC_URL + '/img/bg-blue.svg'})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'bottom left',
                minHeight: '100vh',
                width: '100%',
            }}
        >
            <main className="container" role="main">

                <Link to="/" className="back-btn">← Zurück</Link>
                <h1 className="section-title">Instrumente</h1>
            


          
                    <div className="grid">


                        <Link to="/instrumentelernfeld1" className="maincard card1" aria-label="InstrumenteLernfeld1">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-instrumente.png'} alt="InstrumenteLernfeld1" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">Wissen über Instrumente</h2>
                                <p className="card__desc">Kennst du die verschiedenen Instrumente?</p>
                            </div>
                        </Link>

                        <Link to="/instrumentelernfeld2" className="maincard card2" aria-label="InstrumenteLernfeld2">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-instrumente.png'} alt="InstrumenteLernfeld2" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">Die verschiedenen Instrumentengruppen</h2>
                                <p className="card__desc">Zu welcher Instrumentengruppe gehört das Instrument?</p>
                            </div>
                        </Link>
                    </div>
                    </main>
                </div>
         

    );
}

export default Instrumente;